<template>
  <el-dialog
    title="批量设置可售区域"
    :visible.sync="areaFormVisible"
    width="420px"
    :before-close="cancelHandle"
    class="area-dialog"
    :append-to-body="true"
  >
    <el-form :model="areaForm" :rules="areaRules" ref="areaForm">
      <el-form-item label="可售区域：" label-width="100px" prop="salesScopeId">
        <el-select
          @change="areaChange"
          v-model="areaForm.salesScopeId"
          filterable
          clearable
          placeholder="请选择可售区域"
        >
          <el-option
            v-for="item in areaArr"
            :key="item.salesScopeId"
            :label="item.salesScopeName"
            :value="item.salesScopeId"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label label-width="100px" class="message-box">
        <p class="message">如无销售规则，请先前往“可售区域设置”菜单设置</p>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="cancelHandle">取 消</el-button>
      <el-button type="primary" @click="areaHandle">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    areaFormVisible: {
      type: Boolean,
      default: false
    },
    areaArr: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      areaForm: { salesScopeId: '' },
      areaRules: {
        salesScopeId: [{ required: true, message: '请选择可售区域', trigger: 'change' }]
      }
    }
  },
  methods: {
    cancelHandle() {
      this.$refs.areaForm.resetFields()
      this.$emit('update:areaFormVisible', false)
    },
    // 区域改变
    areaChange() {},
    // 确定按钮
    areaHandle() {
      this.$refs.areaForm.validate(valid => {
        if (valid) {
          this.$emit('areaHandle', this.areaForm.salesScopeId)
          this.$refs.areaForm.resetFields()
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.area-dialog {
  ::v-deep .el-select {
    width: 100%;
  }
  .message-box {
    margin-bottom: 0;
    ::v-deep .el-form-item__content {
      line-height: 1;
      font-size: 12px;
      color: #999999;
    }
  }
}
</style>
